import { render } from "./CoverageMapEmbed.vue?vue&type=template&id=57713a36&scoped=true"
import script from "./CoverageMapEmbed.vue?vue&type=script&lang=js"
export * from "./CoverageMapEmbed.vue?vue&type=script&lang=js"

import "./CoverageMapEmbed.vue?vue&type=style&index=0&id=57713a36&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57713a36"]])

export default __exports__